import { useIsAuthenticated } from '@azure/msal-react';
import { Outlet, createRootRoute } from '@tanstack/react-router';
import { AppLayout } from '@/components/layout/AppLayout';
import { LoginScreen } from '@/features/identity/LoginScreen';

/**
 * Rota raiz. Decide entre tela de login (sem sessão) e o shell autenticado (sidebar + topbar
 * + Outlet das subrotas). As subrotas vivem em src/routes/ (pipeline, tarefas, originacao,
 * portfolio, dashboards) e só renderizam dentro do shell.
 */
export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
